"use client";

import { createContext, type ReactNode, useContext } from "react";

import { SelectedCampaign } from "@/lib/ecid/ecid";

const CampaignContext = createContext<SelectedCampaign | null>(null);

export function CampaignProvider({ children, value }: CampaignProviderProps) {
  if (value && typeof window !== "undefined") {
    window.campaignBean = value;
  }
  return (
    <CampaignContext.Provider value={value}>
      {children}
    </CampaignContext.Provider>
  );
}

export type CampaignProviderProps = {
  children: ReactNode;
  value: SelectedCampaign | null;
};

export function useCampaign(): SelectedCampaign | null {
  return useContext(CampaignContext);
}
